import { GridItem, Stack, Text } from '@chakra-ui/react';
import { getPrettyAircraftType, modelUtils, prettyDate } from '@pelicargo/utils';

import { FlightSegmentWitAirports } from './QuoteVariantFlightPath';

export const QuoteVariantFlightSegment = ({ segment }: { segment: FlightSegmentWitAirports }) => {
  const originTimeZone = segment?.origin_airport?.time_zone;
  const destinationTimeZone = segment?.destination_airport?.time_zone;

  return (
    <>
      <GridItem colSpan={2}>
        <Stack direction="row" spacing={3}>
          <Text textStyle="bodySmallRegular" fontWeight="medium" w="39px">
            {segment.origin_airport_id}
          </Text>
          <Text textStyle="bodySmallRegular">
            {prettyDate(segment.departs_at, { showTime: true, timeZone: originTimeZone })}
          </Text>
        </Stack>
      </GridItem>
      <GridItem colSpan={2}>
        <Stack direction="row" spacing={3}>
          <Text textStyle="bodySmallRegular" fontWeight="medium" w="39px">
            {segment.destination_airport_id}
          </Text>
          <Text textStyle="bodySmallRegular">
            {prettyDate(segment.arrives_at, { showTime: true, timeZone: destinationTimeZone })}
          </Text>
        </Stack>
      </GridItem>
      <GridItem colSpan={1}>
        <Text textStyle="bodySmallRegular">{modelUtils.flightSegment.duration(segment).prettyDuration}</Text>
      </GridItem>
      <GridItem colSpan={1}>
        <Text textStyle="bodySmallRegular">{getPrettyAircraftType(segment.aircraft_type)}</Text>
      </GridItem>
      <GridItem colSpan={1}>
        <Text textStyle="bodySmallRegular">
          {segment.provider_id} {segment.flight_number}
        </Text>
      </GridItem>
    </>
  );
};
